import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Navbar, Nav } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WhatsappIcon from "../assets/svg/WhatsappIcon";
import EyeIcon from "../assets/svg/EyeIcon";
import { useNavigate } from "react-router-dom";
import logo from "../assets/svg/logo_new.png";
import { useSelector } from "react-redux";
import Fbicon from "../assets/images/head-icon/facebook.png";
import Twitter from "../assets/images/head-icon/twitter.png";
import Telegram from "../assets/images/head-icon/telegram.png";
import Instagram from "../assets/images/head-icon/instagram.png";
import Mobile from "../assets/images/head-icon/mobile.png";
import i18next, { t } from "i18next";
import ModalWrapper from "./ModalWrapper";
import { APP_CONST } from "../config/const";
import RealTimeDate from "../views/components/RealTimeDate";

import Aviator from "../assets/images/icons/aviator.png";
import RightArrow from "../assets/images/icons/right-arrow-grey.png";

import LanguageChange from "../views/components/LanguageChange";

import whatsApp from "../assets/images/icons/whatsapp.png";
import LogoWhite from "../assets/images/logo-white.png";
import MobileMenu from "./MobileMenu";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";

const Header = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const isMobile = window.screen.width <= 767 ? true : false;
  const { appDetails } = useSelector((state) => state.app);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const handleLanguageChange = (value) => {
    i18next.changeLanguage(value.target.value);
    window.location.reload(false);
  };
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState(APP_CONST.AUTH_MODAL.LOGIN);
  const handleModalShow = (modalName) => {
    setShowAuthModals(true);

    setDefaultModal(modalName);
  };

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth >= 992) {
        setIsScrolled(window.scrollY > 150);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          {/* <span onClick={() => setShowNotifications(false)}>
          <AiOutlineClose />
        </span> */}
        </div>
      )) ||
        null}
      <header
        className={isScrolled ? "header bfrlgn secondary" : "header bfrlgn"}
      >
        <div className="top-head d-none d-lg-flex">
          <div className="tophead-left">
            <ul>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.FACEBOOK != ""
                      ? appDetails?.FACEBOOK
                      : "javascript:void(0)"
                  }
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={Fbicon} />
                  <p>Facebook</p>
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  // href={
                  //   appDetails?.TWITTER != ""
                  //     ? appDetails?.TWITTER
                  //     : "javascript:void(0)"
                  // }
                  // target={appDetails?.TWITTER != "" ? "_blank" : ""}
                >
                  <img src={Twitter} />
                  <p>Twitter</p>
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.INSTATGRAM != ""
                      ? appDetails?.INSTATGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={Instagram} />
                  <p>Instagram</p>
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.TELEGRAM != ""
                      ? appDetails?.TELEGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={Telegram} />
                  <p>Telegram Channel</p>
                </a>
              </li>

              <li>
                <a
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? appDetails?.WHATS_APP_URL
                      : "javascript:void(0)"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <img src={Mobile} />
                  <p>Message Us</p>
                </a>
              </li>
            </ul>
          </div>
          <div className="tophead-right">
            <div className="time-date">
              <RealTimeDate />
            </div>
            {!isMobile && (
              <div className="language mr-2 d-none d-md-block">
                <LanguageChange />
              </div>
            )}
            {/* <div className="language">
            <LanguageChange />
          </div> */}
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center nav-head">
          <div className="d-flex align-items-center">
            <div className="logo">
              <a href="/">
                {appDetails?.LOGO_URL && (
                  <>
                    <img
                      src={appDetails?.LOGO_URL}
                      alt="Logo"
                      className="logo-blk"
                    />
                    <img src={LogoWhite} alt="Logo" className="logo-wt" />
                  </>
                )}
              </a>
            </div>
            <Navbar expand="lg">
              <Container>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto">
                    <Nav.Link
                      href=""
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                    >
                      Cricket
                    </Nav.Link>
                    <Nav.Link
                      href=""
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                    >
                      SportsBook
                    </Nav.Link>
                    <Nav.Link
                      href=""
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                    >
                      Live Betting
                    </Nav.Link>
                    <Nav.Link
                      href=""
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                    >
                      Casino
                    </Nav.Link>
                    <Nav.Link
                      href=""
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                    >
                      Live Casino
                    </Nav.Link>
                    <Nav.Link
                      href=""
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                    >
                      <img src={Aviator} alt="Aviator" />
                    </Nav.Link>{" "}
                    <Nav.Link
                      href="/promotion"
                      // onClick={() => {
                      //   handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      // }}
                    >
                      Promotion
                    </Nav.Link>
                    <Nav.Link className="menu__more d-none">
                      More
                      <img src={RightArrow} alt="Aviator" />
                      <div className="othermenu">
                        <ul>
                          <li
                            onClick={() => navigate("/casino/aggapspribe-aviator")}
                          >
                            <a href="/casino/aggapspribe-aviator">
                              <p>
                                <img src={Aviator} alt="Aviator" />
                              </p>
                              <img src={RightArrow} alt="Aviator" />
                            </a>
                          </li>
                          <li
                            onClick={() => navigate("/casino/aggapspribe-aviator")}
                          >
                            <a href="javascript:void(0)">
                              <p>PROMOTIONS</p>
                              <img src={RightArrow} alt="Aviator" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </div>
          <div className="headerRight">
            {
              <ul>
                <li>
                  <a
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? appDetails?.WHATS_APP_URL
                        : "javascript:void(0)"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img src={whatsApp} alt="whatsApp" />
                  </a>
                </li>
              </ul>
            }

            <Button
              variant=""
              onClick={() => {
                handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
              }}
              className="btn-login ms-2"
            >
              LOGIN
            </Button>
            <Button
              variant=""
              // onClick={() => {
              //   navigate("/mobile-number");
              // }}
              onClick={() => {
                handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
              }}
              className="btn-register ms-2"
            >
              JOIN NOW
            </Button>
          </div>
        </div>

        <MobileMenu />

        {/* <Offcanvas
        className={"steps-canvas"}
        show={show}
        onHide={handleClose}
        placement={"end"}
      >
        <Offcanvas.Header closeButton="closeButton" closeVariant="white">
          <Offcanvas.Title>
            <span className="top-heading">Sign in now!</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-steps">
            <h2 className="h2">Hello Again!</h2>
            <p>
              Welcome back, you've
              <br />
              been missed!
            </p>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Control type="text" placeholder="Enter Username*" />
              </Form.Group>
              <Form.Group
                className="mb-3 position-relative"
                controlId="formBasicPassword"
              >
                <Form.Control type="password" placeholder="Password*" />
                <span className="icon">
                  <EyeIcon />
                </span>
              </Form.Group>
              <div className="d-flex justify-content-end mb-3">
                <a className="form-link" href="#">
                  Password Recovery
                </a>
              </div>
              <Button variant="primary" type="submit">
                Sign in
              </Button>
            </Form>
            <div className="sign-up mt-4">
              Not a member?
              <br />
              <a href="register">Sign Up Now</a>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas> */}

        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            handleClose={setShowAuthModals}
          />
        )}
      </header>
    </>
  );
};

export default Header;
